import Modal from "react-bootstrap/Modal";
import React, { useEffect, useState } from "react";
// import { useDispatch } from "react-redux";
import Constants from "../../../../common/Constants";
import ItemService from "../../../../services/commonService";
import { toastFunc } from "../../../../components/common/util";
import { useTranslation } from "react-i18next";

import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import QRCode from "react-qr-code";
import Navbar from "react-bootstrap/Navbar";
import { formatDate, formatDateTime } from "../../../../common/Validations";
import {
  getJobcardReportFooter,
  loadJobcardRevisingMetadata,
  REVISING_REPORT_TYPES,
  loadSizeMasterByCode,
} from "../../../../common/JobcardPrintUtils";
const moment = require("moment");

const PrintStatusReports = (props) => {
  // const dispatch = useDispatch();
  const [jobcardData, setJobcardsData] = useState([]);
  // eslint-disable-next-line
  const [sizeMasterByCode, setSizeMasterByCode] = useState({});
  const [revisingMetadata, setRevisingMetadata] = useState({});
  const { t } = useTranslation();
  const loadDepartmentList = async (jobcardArr) => {
    try {
      let param = {
        url: "getJobcardTransactionByJobCard",
        page: Constants.TRANSACTION.ORDERCONFIRMATION.name,
        jobcard: jobcardArr,
      };
      await ItemService.getTransactionListDataById(param).then((item) => {
        if (item?.status === 200) {
          setJobcardsData(item?.data);
        } else {
          console.log(">> Error: Loading getApplicationMaster");
        }
      });
    } catch (error) {
      console.error("Error in handleStartStopSuccess:", error);
      toastFunc(
        Constants.MASTER.TOAST.error,
        t("msg_trasaction.msg_teamlead_acknowledge.error_occurred"),
        4000,
      );
    }
  };

  useEffect(() => {
    if (props?.selectedItems?.length > 0) {
      const jobcardArr = [];
      props?.selectedItems.map((value) => jobcardArr.push(value.jobcard));
      loadDepartmentList(jobcardArr);
      loadSizeMasterByCode(props.selectedItems)
        .then(setSizeMasterByCode)
        .catch((error) => {
          console.error("Error loading size master print data:", error);
          setSizeMasterByCode({});
        });
        console.log(">> REVISING_REPORT_TYPES.BATCH_REPORT,", REVISING_REPORT_TYPES.BATCH_REPORT,);
        
      loadJobcardRevisingMetadata(
        props.selectedItems,
        REVISING_REPORT_TYPES.BATCH_REPORT,
      )
        .then(setRevisingMetadata)
        .catch((error) => {
          console.error("Error loading jobcard revising metadata:", error);
          setRevisingMetadata({});
        });
    } else {
      setSizeMasterByCode({});
      setRevisingMetadata({});
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);

  function applyPrintStyles() {
    const style = document.createElement("style");
    style.textContent = ``;
    document.head.appendChild(style);
  }

  window.onbeforeprint = applyPrintStyles;

  const printModalContent = () => {
    const printWindow = window.open("", "", "height=842,width=1295");
    const modalContent = document.getElementById("printable-area").innerHTML;

    printWindow.document.write("<html><head><title>Print</title>");
    printWindow.document.write(
      '<link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css">',
    );
    printWindow.document.write("<style>");
    printWindow.document.write(`

      @media print {
        /* Add general page margin to add space around the content */

        @page {
          size: A4 portrait;  /* Ensure the page size is A4 in portrait mode */
          margin: 1in;  /* Set a 1-inch margin around the entire page (can be adjusted) */
        }

        * {
          -webkit-print-color-adjust: exact !important;
          print-color-adjust: exact !important;
        }
         .report-title-line {
          display: flex !important;
          flex-direction: row !important;
          justify-content: space-between;
          width: 100%;
          white-space: nowrap;
          margin-top:5px;
        }

        .report-title-line > div {
          flex: 1;
          padding: 0;
          margin: 0;
          text-align: left;
        }

        .report-title-line > div:last-child {
          text-align: right;
        }

        .page-break {
          page-break-before: always; /* Forces content to start on a new page */
           break-before: page;        /* Modern browsers */
        }

        .page-break  {
          margin: 5mm; /* Might not work alone */
          padding: 5mm; /* More reliable for visible space */
        }

        .page-break tr,
        .page-break td {
          height: 30px !important;
        }

        
        /* Table Styling */
        table.jobcard-content-table {
          width: 100%; /* Ensure the table takes up full width */
          border-collapse: collapse; /* Collapse the table borders */
          page-break-before: always; /* Force a page break before this table */
          padding: 10px; /* Add padding inside the table */
        }
          .jobcard-content-table {
            width: 100%;
            border-collapse: collapse;
            margin-top: 20px;
          }

        .telma-header {
          text-align: center;
          text-decoration: underline;
        }
          .telma-detail {
            display:block;
            text-align: center;
            width:100%;
          }
            .jobcard-singlerow {
            text-align: center !important;
          }

        table.jobcard-content-table td, table.jobcard-content-table th {
          border: 2px solid #000000; /* Add borders to the table cells */
          padding: 5px 8px; /* Padding inside the cells to give some space */
          text-align: left; /* Align text to the left */
        }

        /* QR Code cell (with rowspan) styling */
        .qr-code-cell {
          padding: 10px; /* Padding inside the QR code cell */
          text-align: center; /* Center the QR code */
          vertical-align: middle; /* Center QR code vertically */
        }

        /* Styling for text content and card content */
        .card-body {
          padding: 20px; /* Add padding inside the card body */
        }

        /* Prevent content from breaking into multiple pages */
        table.jobcard-content-table tr {
          page-break-inside: avoid; /* Prevent rows from breaking across pages */
        }

        .jobcard-detail-table {
          width: 100%;
          border-collapse: collapse;
          table-layout: fixed; /* Equal column widths */
          font-size: 11px;
          
          th:first-child,
          td:first-child {
            width: 16%; /* First column gets more space */
          }

          th:not(:first-child),
          td:not(:first-child) {
            width: 10%; /* Adjust based on how many columns you have */
          }
        }

          .jobcard-detail-table th,
            .jobcard-detail-table td {
              border: 2px solid #000;
              padding: 4px;
              word-wrap: break-word;
              text-align: left;
              height: 40px;
            }

        /* Job card content */
        .jobcard-content-bold {
          font-weight: bold;
        }

        /* Additional spacing between the QR code and text */
        .jobcard-qr-code {
          padding: 5px; /* Add padding around the QR code */
        }

        /* Add padding to any text elements inside the table */
        .jobcard-title-content, .jobcard-priority, .jobcard-content-bold {
          padding-bottom: 2px; /* Provide some space between lines of text */
        }

        /* Add spacing between the rows of the table */
        tr + tr {
          margin-top: 10mm; /* Adds space between each row */
        }
        
        /* Add space around the body content */
        body {
          padding: 20px; /* Padding around the entire page content */
          margin: 0;
        }

          .jobcard-qr-code {
          display: flex; /* Use flexbox to center content */
          justify-content: center; /* Center horizontally */
          align-items: center; /* Center vertically */
          width: 100%; /* Ensure the QR code container takes full width */
          height: auto; /* Adjust the height based on content */
          padding: 5px; /* Optional: Add some padding around the QR code */
          margin: 0 auto; /* Center the QR code container in the page */
        }

        /* You can also set a fixed size for QR code to make sure it scales well */
        .qr-code {
          max-width: 120px; /* Max width of the QR code */
          width: 100%; /* Make sure the QR code fits inside its container */
          height: auto; /* Maintain aspect ratio */
        }
          .jobcard-priority {
          color: #0047ab !important; /* Default priority color */
          text-align: center;
          font-weight:bold !important;
        }

        .jobcard-priority-urgent {
          color: red !important; /* Priority 'urgent' color */
          text-align: center;
          font-weight:bold;
          font-weight:bold !important;
        }

        .jobcard-title-content {
          text-align: center !important;
          font-weight: bold;
          color: #0047ab;
          margin-bottom:2px;
        }

        .jobcard-title-content-jobcard {
          margin-top:10px;
          text-align: center !important;
          font-weight: bold;
          color: #0047ab;
        }
      }

    `);
    printWindow.document.write("</style>");
    printWindow.document.write("</head><body>");
    printWindow.document.write(modalContent);
    printWindow.document.write("</body></html>");
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
  };
  const maxRejectionLength = Math.max(
    ...(jobcardData?.map((val) => val?.rejectionRecords?.length || 0) || [0]),
  );

  const getJobcardGrandTotal = (jobcard) => {
    return jobcardData
      ?.filter((val) => val?.jobcard === jobcard)
      .reduce((sum, val) => {
        const records = val?.rejectionRecords || [];

        const totalCount = records.reduce(
          (subSum, rec) => subSum + Number(rec?.count || 0),
          0
        );

        return sum + totalCount;
      }, 0);
  };

  const maxReworkLength = Math.max(
    ...(jobcardData?.map((val) => val?.reworkRecords?.length || 0) || [0]),
  );

  const getJobcardReworkGrandTotal = (jobcard) => {
    return jobcardData
      ?.filter((val) => val?.jobcard === jobcard)
      .reduce((sum, val) => {
        const records = val?.reworkRecords || [];

        const totalCount = records.reduce(
          (subSum, rec) => subSum + Number(rec?.count || 0),
          0
        );

        return sum + totalCount;
      }, 0);
  };

  const renderSheetDetails = (value) => (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        flexWrap: "wrap",
        gap: "0.5rem 1rem",
        fontSize: "1rem",
        textAlign: "left",
        marginBottom: "0.5rem",
      }}
    >
      <span>Batch No. : {value.batch || "-"}</span>
      <span>Size : {value.sizeCode || "-"}</span>
    </div>
  );

  const renderReportFooter = (value) => {
    const footer = getJobcardReportFooter({
      sizeMasterByCode,
      sizeCode: value.sizeCode,
      jobcard: value.jobcard,
      revisingMetadata,
    });

    return (
      <div className="report-title-line">
        <Col xs={12} sm={6} md={6} lg={6}>
          {footer.reportTitle}
        </Col>
        <Col xs={12} sm={3} md={3} lg={3}>
          Rev No: {footer.reviseNumber}
        </Col>
        <Col xs={12} sm={3} md={3} lg={3} className="text-end">
          Date: {footer.reviseDate}
        </Col>
      </div>
    );
  };

  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      dialogClassName="modal-90w"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          View All QR Codes
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="qr-code">
        <Navbar expand="lg" className="qr-code-navbar">
          <Button
            class="accordion-button"
            type="button"
            variant="primary"
            onClick={printModalContent}
          >
            <i className="bi bi-printer"></i> {"Print"}
          </Button>
        </Navbar>
        <div id="printable-area">
          <Row>
            {props.selectedItems.map((value, index) => (
              <>
                <Col
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  key={index}
                  className="mb-4"
                >
                  <table className="jobcard-content-table">
                    <thead>
                      <th colSpan="5">
                        <h4 className="telma-header">
                          TELMA MICRO NEEDLES PVT LTD
                        </h4>
                        <span className="telma-detail">
                          NO-56/6, MAJARA HOSAHALLI MAIN ROAD, DODDABALLAPURA
                          INDUSTRIAL AREA, BANGALORE-561203
                        </span>
                      </th>
                    </thead>
                    <tbody>
                      <tr>
                        <td
                          className="jobcard-content-bold"
                          style={{ width: "20%" }}
                        >
                          Size :{" "}
                        </td>
                        <td>{value.sizeCode}</td>
                        <td className="jobcard-content-bold">
                          Required Date :
                        </td>
                        <td>{value.requiredDate}</td>
                        <td
                          className="qr-code-cell"
                          rowSpan="6"
                          style={{ width: "20%" }}
                        >
                          <Card.Title
                            className={
                              value.priority === "urgent"
                                ? "jobcard-priority-urgent"
                                : "jobcard-priority"
                            }
                          >
                            {value.priority.toUpperCase()}
                          </Card.Title>
                          <Card.Text className="jobcard-title-content">
                            {`${value?.siliconize || ""}`}
                          </Card.Text>
                          <span className="jobcard-qr-code">
                            <QRCode size={115} value={value.jobcard} />
                          </span>
                          <Card.Text className="jobcard-title-content-jobcard">
                            {value.jobcard}
                          </Card.Text>
                        </td>
                      </tr>
                      <tr>
                        <td className="jobcard-content-bold">Batch No. :</td>
                        <td>{value.batch}</td>
                        <td className="jobcard-content-bold">Plan :</td>
                        <td>{moment(value.plan).format("MMM-YYYY")}</td>
                      </tr>
                      <tr>
                        <td className="jobcard-content-bold">Batch Qty :</td>
                        <td>{parseInt(value.originalQuantityPerJobCard)}</td>
                        <td className="jobcard-content-bold">Plan Type :</td>
                        <td>{value.planType}</td>
                      </tr>
                      <tr>
                        <td className="jobcard-content-bold">Batch Dozens :</td>
                        <td>{value.batchTotalQtyDozen}</td>
                        <td className="jobcard-content-bold">Customer :</td>
                        <td>{value.customerCode}</td>
                      </tr>
                      <tr>
                        <td className="jobcard-content-bold">Wire Trace Number :</td>
                        <td>{value.materialTraceNumber || "-"}</td>
                        <td className="jobcard-content-bold">Weight in Grams :</td>
                        <td>
                          {sizeMasterByCode[value.sizeCode]?.weightInGrams ?? "-"}
                        </td>
                      </tr>
                      <tr>
                        <td className="jobcard-content-bold">Remarks :</td>
                        <td colSpan="3">{value.remarks}</td>
                      </tr>
                      <tr>
                        <td
                          className="jobcard-content-bold jobcard-singlerow"
                          colSpan="5"
                        >
                          PRODUCTION DATA SHEET
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <table className="jobcard-detail-table mt-1">
                    <thead>
                      <tr>
                        <th>DEPARTMENT</th>
                        <th>DATE</th>
                        <th>OPERATOR</th>
                        <th>QTY NOS</th>
                        {/* <th>GRAMS</th> */}
                        <th>MC.NO</th>
                        <th>START TIME</th>
                        <th>END TIME</th>
                        {/* <th>MAT CONSP</th> */}
                        <th>TL/SUPR</th>
                        <th>CM.NO</th>
                        <th>REMARKS</th>
                      </tr>
                    </thead>
                    <tbody>
                      {jobcardData?.map(
                        (val, index) =>
                          value.jobcard === val.jobcard && (
                            <tr key={index}>
                              <td>{val.toDeptName}</td>
                              <td>{formatDate(val.from)}</td>
                              <td>{val.operatorUserName}</td>
                              <td>{val.count}</td>
                              {/* <td></td> */}
                              <td>{val.machineCode}</td>
                              <td>{formatDateTime(val.from)}</td>
                              <td>{formatDateTime(val.to)}</td>
                              {/* <td></td> */}
                              <td>{val.loginUserName}</td>
                              <td>{val?.chemicalBatchNo}</td>
                              <td></td>
                            </tr>
                          ),
                      )}
                    </tbody>
                  </table>
                </Col>
                {renderReportFooter(value)}

                <table className="jobcard-detail-table mt-1 page-break">
                  <caption
                    style={{
                      captionSide: "top",
                      textAlign: "center",
                      fontWeight: "bold",
                      fontSize: "1.2rem",
                      padding: "0.5rem",
                    }}
                  >
                    {renderSheetDetails(value)}
                    <span className="jobcard-content-bold jobcard-singlerow">
                      INPROCESS INSPECTION QUALITY CONTROL DATA SHEET
                    </span>
                  </caption>

                  <tbody>
                    {jobcardData?.map((val, index) => {
                      const records = val?.rejectionRecords || [];
                      const totalCount = records.reduce(
                        (sum, rec) => sum + Number(rec.count || 0),
                        0,
                      );
                      const emptySlots = maxRejectionLength - records.length;

                      return (
                        value.jobcard === val.jobcard && (
                          <>
                            <React.Fragment key={index}>
                              {/* Header Row */}
                              <tr>
                                <td rowSpan={2}>{val.toDeptName}</td>
                                {records.map((record, i) => (
                                  <td key={`header-${i}`}>
                                    <b>{record.reasonName}</b>
                                  </td>
                                ))}
                                {/* Fill in empty header cells if needed */}
                                {Array.from({ length: emptySlots }).map(
                                  (_, i) => (
                                    <td key={`header-empty-${i}`}></td>
                                  ),
                                )}
                                <td>
                                  <b>Total</b>
                                </td>
                              </tr>

                              {/* Value Row */}
                              <tr>
                                {records.map((record, i) => (
                                  <td key={`value-${i}`}>{record.count}</td>
                                ))}
                                {/* Fill in empty value cells if needed */}
                                {Array.from({ length: emptySlots }).map(
                                  (_, i) => (
                                    <td key={`value-empty-${i}`}></td>
                                  ),
                                )}
                                <td>
                                  <b>{totalCount}</b>
                                </td>
                              </tr>
                            </React.Fragment>
                          </>
                        )
                      );
                    })}
                    <tr style={{ backgroundColor: "#d1d1d1ff" }}>
                      <td colSpan={maxRejectionLength + 1}>
                        <b>Grand Total</b>
                      </td>
                      <td>
                        <b>{getJobcardGrandTotal(value.jobcard)}</b>
                      </td>
                    </tr>
                  </tbody>
                </table>

                {renderReportFooter(value)}

                <table className="jobcard-detail-table mt-1 page-break">
                  <caption
                    style={{
                      captionSide: "top",
                      textAlign: "center",
                      fontWeight: "bold",
                      fontSize: "1.2rem",
                      padding: "0.5rem",
                    }}
                  >
                    {renderSheetDetails(value)}
                    <span className="jobcard-content-bold jobcard-singlerow">
                      REWORK DATA SHEET
                    </span>
                  </caption>

                  <tbody>
                    {jobcardData?.map((val, index) => {
                      const records = val?.reworkRecords || [];

                      const totalCount =
                        val?.reworkCount ??
                        records.reduce(
                          (sum, rec) => sum + Number(rec.count || 0),
                          0,
                        );

                      const emptySlots = maxReworkLength - records.length;

                      return (
                        value.jobcard === val.jobcard && (
                          <React.Fragment key={`rework-${index}`}>
                            {/* Header Row */}
                            <tr>
                              <td rowSpan={2}>{val.toDeptName}</td>

                              {records.map((record, i) => (
                                <td key={`rework-header-${i}`}>
                                  <b>{record.reasonName}</b>
                                </td>
                              ))}

                              {/* Fill empty header cells */}
                              {Array.from({ length: emptySlots }).map(
                                (_, i) => (
                                  <td key={`header-empty-${i}`}></td>
                                ),
                              )}

                              <td>
                                <b>Total</b>
                              </td>
                            </tr>

                            {/* Value Row */}
                            <tr>
                              {records.map((record, i) => (
                                <td key={`rework-value-${i}`}>
                                  {record.count}
                                </td>
                              ))}

                              {/* Fill empty value cells */}
                              {Array.from({ length: emptySlots }).map(
                                (_, i) => (
                                  <td key={`rework-value-empty-${i}`}></td>
                                ),
                              )}

                              <td>
                                <b>{totalCount}</b>
                              </td>
                            </tr>
                          </React.Fragment>
                        )
                      );
                    })}

                    <tr style={{ backgroundColor: "#d1d1d1ff" }}>
                      <td colSpan={maxReworkLength + 1}>
                        <b>Grand Total</b>
                      </td>

                      <td>
                        <b>{getJobcardReworkGrandTotal(value.jobcard)}</b>
                      </td>
                    </tr>
                  </tbody>
                </table>

                {renderReportFooter(value)}
              </>
            ))}
          </Row>
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default PrintStatusReports;
